import { useState, type FormEvent } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center gap-4 px-4 md:px-6">
        <h1 className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-archive-2-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              黑料91
            </span>
            <span className="mt-0.5 text-[10px] tracking-[0.24em] text-foreground-500">
              黑料仓库
            </span>
          </span>
        </h1>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="ml-auto hidden items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-2 lg:flex"
        >
          <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-base" />
          </span>
          <input
            type="text"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="搜专题名、标签或来源"
            className="w-48 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 xl:w-60"
          />
          <button
            type="submit"
            className="rounded-full bg-foreground-950 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            检索
          </button>
        </form>

        <a
          href="#download"
          className="ml-auto hidden shrink-0 items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 lg:flex whitespace-nowrap cursor-pointer"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-download-2-line text-base" />
          </span>
          进入仓库
        </a>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="展开菜单"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <form
            onSubmit={handleSearch}
            className="mb-4 flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-2.5"
          >
            <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base" />
            </span>
            <input
              type="text"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="搜专题名、标签或来源"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </form>
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md border border-background-200 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#download"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer"
          >
            <i className="ri-download-2-line" />
            进入仓库
          </a>
        </div>
      )}
    </header>
  );
}